import React , {Fragment} from 'react'
import AllMessages from './AllMessages'
import Choosegroup from './Choosegroup'
import InfoBar from './InfoBar'
import InputBox from './InputBox'
import { useSelector } from 'react-redux'

function Messagebox() {
    let room = useSelector(state => state.room)
    let content;
    
    if (room.name.trim() === "") {
        content = <Choosegroup></Choosegroup>
    }
    else {  
        content = (
            <Fragment>
                <InfoBar></InfoBar>
                <AllMessages></AllMessages>
                <InputBox></InputBox>
            </Fragment>
        )
    }

    return (
        <div className="right-chatbox-container">
            {content}
        </div>
    )
}

export default Messagebox